<template>
  <a-flex v-if="!!group.requests.length" vertical gap="small">
    <a-button
      @click="selectRequest(item.id)"
      :ghost="selectedRequestId === item.id"
      v-for="item in group.requests"
      :key="item.id"
      :type="selectedRequestId === item.id ? 'primary' : 'text'"
    >
      <a-flex justify="space-between" align="center" gap="small">
        <a-flex align="center" justify="start" gap="small" style="flex-grow: 1">
          <a-typography-text
            :copyable="{ text: item.partnerId, tooltip: true }"
          >
            <template #copyableTooltip="{ copied }">
              {{ copied ? "ID партнера скопирован" : "Копировать ID партнера" }}
            </template>
            <template #copyableIcon="{ copied }">
              <CheckOutlined style="color: #0f884c" v-if="copied" />
              <UserOutlined style="color: #0f884c" v-else />
            </template>
          </a-typography-text>
          <a-typography-text
            :content="`${item.number}: ${item.theme}`"
            ellipsis
          />
        </a-flex>
        <a-badge
          v-if="!!chatStore.unreadMessagesCount[item.id]"
          :count="chatStore.unreadMessagesCount[item.id]"
          style="align-self: end"
        />
      </a-flex>
    </a-button>
    <a-flex
      align="center"
      justify="center"
      style="width: 100%"
      v-if="!!pagination.total && pagination.total > pagination.pageSize"
    >
      <a-pagination
        v-model:current="pagination.current"
        :total="pagination.total"
        v-model:pageSize="pagination.pageSize"
        :pageSizeOptions="pagination.pageSizeOptions"
        :defaultPageSize="pagination.defaultPageSize"
        @change="pagination.onChangePagination"
        :showQuickJumper="pagination.showQuickJumper"
        :showSizeChanger="pagination.showSizeChanger"
        :showLessItems="pagination.showLessItems"
        :showTotal="pagination.showTotal"
        :size="'small'"
      />
    </a-flex>
  </a-flex>
  <a-empty
    v-else
    :description="`Нет обращений в статусе '${group.statusName}'`"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import router from "@/router";
import { RequestStatus, type PaginationConfig } from "@/api/api.dto";
import { useSupportAdminStore } from "@/stores/support/support-admin.store";
import { useChatStore } from "@/stores/chat/chat.store";
import { UserOutlined, CheckOutlined } from "@ant-design/icons-vue";

const { group } = defineProps<{
  group: {
    statusName: string;
    status: RequestStatus;
    requests: {
      status: RequestStatus;
      theme: string;
      number: number;
      id: number;
      userId: string;
      userName: string;
      partnerId: string;
    }[];
  };
}>();

const supportAdminStore = useSupportAdminStore();
const chatStore = useChatStore();

const pagination = computed<PaginationConfig>(
  () => supportAdminStore.pagination[group.status]!,
);

const selectedRequestId = computed(() => chatStore.currentChatId);

const selectRequest = (supportRequestId: number) => {
  router.push({
    name: "supportAdminRequestSingle",
    params: { supportRequestId },
  });
};
</script>

<style scoped lang="scss">
.isStatusSelected {
  border-color: var(--color-primary);
}
.button-expand {
  --size: 15px;
  padding: 0;
  flex-shrink: 0;
  font-size: var(--size);
  line-height: 1;
  width: var(--size);
  height: var(--size);
  margin-left: auto;

  svg {
    width: 100%;
    height: 100%;
  }

  &.expanded {
    transform: rotate(180deg);
  }
}
</style>
